export default __webpack_public_path__ + "static/media/0.c93dd979.jpg";